import { useEffect } from 'react';
import { pick } from 'lodash-es';
import { produce } from 'immer';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import { getItem, removeItem, setItem } from 'utils/storage/session.lib.js';
import useSafeState from 'utils/useSafeState.js';

function getStoredData(key) {
  const storedData = getItem(key);
  if (!storedData) {
    return null;
  }
  const newMedia = storedData?.files?.newMedia;
  if (newMedia) {
    storedData.files.newMedia = storedData.files.newMedia.filter((m) => Boolean(m.file.name) && !m.loading);
  }
  return storedData;
}

function useRecoveredData(...args) {
  const role = useCurrentRole();
  const uniqueId = role?.uniqueId;
  const key = [...args, uniqueId].join('_');
  const [data, setData] = useSafeState(getStoredData(key));

  useEffect(() => {
    const storedData = getStoredData(key);
    setData(storedData);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

  function changeData(newData, skipSave) {
    setData(newData);
    if (skipSave || !key) {
      return;
    }
    if (!newData) {
      removeItem(key);
    } else {
      const result = produce(newData, (draft) => {
        draft.fromStorage = true;
        if (draft.files?.newMedia) {
          draft.files.newMedia.forEach((m) => {
            // eslint-disable-next-line no-param-reassign
            m.file = pick(m.file, ['name', 'size', 'type']);
          });
        }
      });
      setItem(key, result);
    }
  }

  return [data, changeData];
}

export default useRecoveredData;
